import { ComponentProps } from 'react'
import 'highlight.js/styles/mono-blue.css'
import { HtmlContent } from 'components/HtmlContent/index'

export const HtmlContentWithCode = (props: ComponentProps<typeof HtmlContent>) => {
    return <HtmlContent {...props} />
}
